import GraphQLLocationDAOFactory from "../../../../lib/location/dao/graphql/GraphQLLocationDAOFactory";
import { useQuery } from "react-query";

const locationDAO = GraphQLLocationDAOFactory.getInstance();

export const useLocations = (propertyId: string) => {
    const listLocationsQueryResult = useQuery({
        queryKey: ['locations', propertyId],
        queryFn: async () => {
            return await locationDAO.getLocationsByPropertyId(propertyId);
        },
        keepPreviousData: true
    });

    return listLocationsQueryResult;
};

